export interface HrefLangLink {
  href: string;
  hreflang: string;
}

export interface HrefLangInput {
  locale: string;
  url?: string;
  type?: string;
  linkedArticleUrl?: string;
  section?: string;
}

export function isUsBlog(country: string): boolean {
  return country === 'us';
}

export function usContentRobots(): string {
  return 'noindex, follow';
}

export function stripPagingFromUrl(pageURL: string): string {
  if (pageURL && pageURL.includes('/page/')) {
    return pageURL.replace(/\/page\/[01]$/, '');
  }
  return pageURL;
}

export function hrefLangLinks(_input: HrefLangInput): HrefLangLink[] {
  return [];
}
